import React from 'react'
import PropTypes from 'prop-types'
import { isArray } from 'lodash'
import { ProfileField } from '../../../../../../components/generic'
import ProfileFamilyInviteField from './ProfileFamilyInviteField'
import { colors } from '@lmc/common/constants'
import { formatAddress } from '../../../../../../common/utils'
import { isBrowser, isTablet } from 'react-device-detect'
import { darken, lighten } from '../../../../../../LEGACY/colorUtils'
import { relationshipOptions, roleOptions } from '@lmc/ts-common'

const isDesktop = isBrowser || isTablet

export default function ResidentImportantContact({
  contact,
  carer,
  residentName,
  index,
  resendInvite,
  family,
  familySetupComplete,
  openModal
}) {
  const badgeMargins = isDesktop ? '0px 0px 0px 12px' : '6px 12px 6px 0px'

  const contactRole =
    (contact?.type === 'Personal' ? relationshipOptions : roleOptions)?.find(
      (option) => option.value === contact.relationship
    )?.label || contact.relationship

  return (
    <div className="lmc-card">
      <div style={styles.titleContainer}>
        <div style={styles.title}>{getValue('name', contact)}</div>
        <div style={styles.titleBadge}>
          {contact.lpa &&
            isArray(contact.lpaTypes) &&
            contact.lpaTypes.map((type, i) => (
              <div
                key={i}
                style={{
                  ...styles.badge,
                  background: colors.darkgrey,
                  color: 'white',
                  margin: badgeMargins
                }}
              >
                LPA {type}
              </div>
            ))}
          <div
            style={{
              ...styles.badge,
              background:
                contact.type === 'Professional'
                  ? lighten(colors.darkblue, 80)
                  : lighten(colors.purple, 80),
              color:
                contact.type === 'Professional'
                  ? darken(colors.darkblue, 30)
                  : darken(colors.purple, 30),
              margin: badgeMargins
            }}
          >
            {contact.type || 'Personal'}
          </div>
        </div>
      </div>
      {contact.relationship && (
        <ProfileField
          badgeText={contact.nextOfKin ? 'Next of kin' : null}
          badgeColor={colors.pink}
          label={contact?.type === 'Personal' ? 'Relationship' : 'Role'}
          value={contactRole}
        />
      )}
      <ProfileField label="Email" value={getValue('email', contact)} />
      {contact.address && (
        <ProfileField label="Address" value={getValue('address', contact)} />
      )}
      {contact.telephone && (
        <ProfileField
          badgeText={contact.contactStatus || null}
          badgeColor={getContactStatusColor(contact.contactStatus)}
          label="Telephone 1"
          value={getValue('telephone', contact)}
        />
      )}
      {contact.telephoneSecondary && (
        <ProfileField
          label="Telephone 2"
          value={getValue('telephoneSecondary', contact)}
        />
      )}
      {contact.type === 'Professional' && contact.contactableTimes && (
        <ProfileField
          label="Contactable times"
          value={getValue('contactableTimes', contact)}
        />
      )}
      {contact.observations && (
        <ProfileField
          label="Observation notes"
          value={getValue('observations', contact)}
        />
      )}
      {family && (
        <ProfileFamilyInviteField
          label="Family App"
          carer={carer}
          familySetupComplete={familySetupComplete}
          contact={contact}
          residentName={residentName}
          resendInvite={resendInvite}
          index={index}
          openModal={openModal}
        />
      )}
    </div>
  )
}

const getContactStatusColor = (status) => {
  if (status === 'Priority') return colors.green
  if (status === 'Secondary') return colors.orange
  if (status === 'Do not contact') return colors.red
}

const getValue = (key, contact) => {
  const value = contact[key]
  if (!value) return <span style={styles.noInfo}>No information entered</span>
  if (key === 'name') {
    return `${value.first} ${value.last}`
  }
  if (key === 'address') {
    return formatAddress(value)
  }
  return value
}

const styles = {
  badge: {
    alignSelf: 'center',
    display: 'inline-block',
    fontWeight: 'bold',
    float: 'right',
    fontSize: 12,
    padding: '3px 12px',
    borderRadius: 15
  },
  noInfo: {
    color: colors.black
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18
  },
  titleBadge: {},
  titleContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: isDesktop ? 'space-between' : 'flex-start'
  }
}

ResidentImportantContact.propTypes = {
  contact: PropTypes.object.isRequired,
  resendInvite: PropTypes.func,
  contactNumber: PropTypes.number.isRequired
}
